import * as React from 'react';
import { LocalForm, Control, Errors, actions } from 'react-redux-form';
import { isDecimal, getDefaultErrorMessages, hasValue, smallMoneyMax, valueIsLessThanN } from '@common/validators';
import { ExcludedZipViewModel } from '@models/Vendor';
import { parseCurrency } from '@common/parsers';

export interface ZipTripChargeComponentProperties {
  readonly zipTripCharges: Array<ExcludedZipViewModel>;
  readonly submitForm: (tripCharges: Array<ExcludedZipViewModel>) => void;
  readonly buttonRef: (button: HTMLButtonElement) => void;
}

interface ZipTripChargeForm {
  zipTripCharges: Array<ExcludedZipViewModel>;
}

interface ZipTripChargeComponentState {
  readonly isSaving: boolean;
  readonly formDispatcher?: Function;
}

const initialState = {
  isSaving: false,
  formDispatcher: undefined
};

export class ZipTripChargeComponent extends React.Component<
  ZipTripChargeComponentProperties,
  ZipTripChargeComponentState
> {
  constructor(props: ZipTripChargeComponentProperties) {
    super(props);
    this.state = initialState;
  }

  handleSubmit = (formData: ZipTripChargeForm) => {
    this.setState({ isSaving: true });
    this.props.submitForm(formData.zipTripCharges);
  };

  handleApplyAll = (formData: { applyAllValue: number }) => {
    this.props.zipTripCharges.map((value: ExcludedZipViewModel, index: number) => {
      if (this.state.formDispatcher) {
        this.state.formDispatcher(
          actions.change(`tripChargesForm.zipTripCharges[${index}].tripCharge`, formData.applyAllValue)
        );
      }
    });
  };

  render() {
    return (
      <>
        {this.props.zipTripCharges &&
          this.props.zipTripCharges.length > 1 && (
            <LocalForm className="form-horizontal" hideNativeErrors={true} onSubmit={this.handleApplyAll}>
              <div className="row">
                <div className="col-xs-1">
                  <Control.text
                    model={`.applyAllValue`}
                    min="0.00"
                    max={smallMoneyMax}
                    step="0.01"
                    type="number"
                    validators={{ required: hasValue, isDecimal, isSmallMoney: valueIsLessThanN(smallMoneyMax) }}
                    parser={parseCurrency}
                    placeholder={'0.00'}
                  />
                  <Errors
                    className="error"
                    model={`.applyAllValue`}
                    show={{ touched: true, focus: false }}
                    messages={getDefaultErrorMessages()}
                  />
                </div>
                <div className="col-xs-2">
                  <button className="btn btn-primary" type="submit">
                    Apply All
                  </button>
                </div>
              </div>
            </LocalForm>
          )}
        <LocalForm
          className="form-horizontal"
          initialState={{ zipTripCharges: this.props.zipTripCharges }}
          model={'tripChargesForm'}
          hideNativeErrors={true}
          onSubmit={this.handleSubmit}
          getDispatch={d => this.setState({ formDispatcher: d })}
        >
          <div className="row">
            <div className="col-xs-9">
              <h2>Zip Code</h2>
            </div>
            <div className="col-xs-3">
              <h2>Trip Charge ($)</h2>
            </div>
          </div>
          {this.props.zipTripCharges.map((value: ExcludedZipViewModel, index: number) => {
            return (
              <div key={index} className="row border-top-bottom">
                <div className="col-xs-9">
                  <h5>{value.zip}</h5>
                  <Control.text model={`.zipTripCharges[${index}].zip`} value={value.zip} className="txt-hidden" />
                </div>
                <div className="col-xs-1">
                  <Control.text
                    model={`.zipTripCharges[${index}].tripCharge`}
                    min="0.00"
                    max={smallMoneyMax}
                    step="0.01"
                    type="number"
                    validators={{ required: hasValue, isDecimal, isSmallMoney: valueIsLessThanN(smallMoneyMax) }}
                    parser={parseCurrency}
                    placeholder={'0.00'}
                  />
                  <Errors
                    className="error"
                    model={`.zipTripCharges[${index}].tripCharge`}
                    show={{ touched: true, focus: false }}
                    messages={getDefaultErrorMessages()}
                  />
                </div>
              </div>
            );
          })}
          <div className="row end-xs">
            <div className="col-xs-12 text-left">
              <button
                className={'btn ' + (this.props.buttonRef ? 'btn-hidden' : 'btn-primary')}
                disabled={!this.props.zipTripCharges || this.props.zipTripCharges.length === 0 || this.state.isSaving}
                type="submit"
                ref={this.props.buttonRef}
              >
                Save
              </button>
            </div>
          </div>
        </LocalForm>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-trade-maintenance/_components/zip-trip-charge.component.tsx